export default __webpack_public_path__ + "static/media/next.d5120c99.svg";